import React, { useEffect } from "react";

import {} from "react-router-dom";

const IdBillFold = () => {
  return <div>IdBillFold</div>;
};

export default IdBillFold;
